import React from 'react';
import Navbar from '../../HomePage/navbar/Navbar';
import Footer from '../../HomePage/Footer/Footer';
import IqacNavbar from '../IqacNavbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faFileExcel, faFileWord, faDownload, faUserTie, faSignOutAlt, faFolder, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import '../IQAC.css';
import './IqacDownloads.css';
import { useAuth } from '../../../context/AuthContext';
import { useState } from 'react';
import { FaHistory } from 'react-icons/fa';
import archivedData from './archived_data.json';



const BASE_PATH = "/files/iqac/downloads";
const ARCHIVED_BASE_PATH = "/files/iqac/downloads/archived";

const copoFiles = [
    { name: "1.THEORY COURSE V2.xlsx", path: `${BASE_PATH}/copo/1.THEORY COURSE V2.xlsx` },
    { name: "2.LABORATORY COURSE V2.xlsx", path: `${BASE_PATH}/copo/2.LABORATORY COURSE V2.xlsx` },
    { name: "3.THEORY CUM LABORATORY COURSE V2.xlsx", path: `${BASE_PATH}/copo/3.THEORY CUM LABORATORY COURSE    V2.xlsx` },
    { name: "4.Project_Work final year V2.xlsx", path: `${BASE_PATH}/copo/4.Project_Work final year V2.xlsx` },
    { name: "5.Project_Work sixth sem V2.xlsx", path: `${BASE_PATH}/copo/5.Project_Work sixth sem V2.xlsx` }
];

const pdfFiles = [
    "1_Timetable v2.pdf", "2_Academic V2.pdf", "3_Project V1.pdf", "4_CO-PO v1.pdf",
    "5_Lab.pdf", "6_Feedback v2.pdf", "7_IIPC.pdf", "8_Research.pdf",
    "9_TrainingFaculty_Staff.pdf", "10_Association.pdf", "11_Budget v1.pdf", "12_Alumni.pdf",
    "13_Test v1.pdf", "14_Placement.pdf", "15_MinutesofMeeting.pdf",
    "16_Departmental Advisory Committee (DAC).pdf", "17_Field Visit.pdf",
    "COE FORMATS.pdf", "LIBRARY.pdf", "PHYSICAL EDUCATION.pdf", "Transport.pdf"
];

const docFiles = [
    "1_Timetable v2.docx", "2_Academic V2.docx", "3_Project V1.docx", "4_CO-PO v1.docx",
    "5_Lab.docx", "6_Feedback v2 (1).docx", "7_IIPC.docx", "8_Research.doc",
    "9_TrainingFaculty_Staff.doc", "10_Association.doc", "11_Budget v1.doc", "12_Alumni.docx",
    "13_Test v1.docx", "14_Placement.doc", "15_MinutesofMeeting.docx",
    "16_Departmental Advisory Committee (DAC).doc", "17_Field Visit.docx",
    "AC-06 v1.xlsx", "AC-07 v1.xlsx", "AC-08 v1.xlsx",
    "COE FORMATS.doc", "LIBRARY.doc", "PHYSICAL EDUCATION.docx", "Transport.docx"
];

// Archived Files (Loaded from JSON generated by script)
const archivedCopoFiles = archivedData.copo || [];
const archivedPdfFiles = archivedData.pdf || [];
const archivedDocFiles = archivedData.doc || [];

const EOMS_BASE_PATH = "/files/iqac/downloads/EOMS";

const eomsCopoFiles = [
    { name: "1.THEORY COURSE.xlsx", path: `${EOMS_BASE_PATH}/COPO/1.THEORY COURSE.xlsx` },
    { name: "2.LABORATORY COURSE.xlsx", path: `${EOMS_BASE_PATH}/COPO/2.LABORATORY COURSE.xlsx` },
    { name: "3.THEORY CUM LABORATORY COURSE.xlsx", path: `${EOMS_BASE_PATH}/COPO/3.THEORY CUM LABORATORY COURSE.xlsx` },
    { name: "4.PROJECT_WORK FINAL YEAR.xlsx", path: `${EOMS_BASE_PATH}/COPO/4.PROJECT_WORK FINAL YEAR.xlsx` },
    { name: "5.PROJECT_WORK THIRD YEAR.xlsx", path: `${EOMS_BASE_PATH}/COPO/5.PROJECT_WORK THIRD YEAR.xlsx` }
];

const excel = [
    { name: "1.AC-06.xlsx", path: `${EOMS_BASE_PATH}/MDF/WORD/AC-06.xlsx` },
    { name: "2.AC-07.xlsx", path: `${EOMS_BASE_PATH}/MDF/WORD/AC-07.xlsx` },
    { name: "3.AC-08.xlsx", path: `${EOMS_BASE_PATH}/MDF/WORD/AC-08.xlsx` },
    { name: "4.CDC_05.xlsx", path: `${EOMS_BASE_PATH}/MDF/WORD/CDC_05.xlsx` },
    { name: "5.CDC_07.xls", path: `${EOMS_BASE_PATH}/MDF/WORD/CDC_07.xls` },
    { name: "6.CDC_08.xls", path: `${EOMS_BASE_PATH}/MDF/WORD/CDC_08.xls` }
];

const eomsMdfFiles = [
    { name: "00_MDI_01 MASTER LIST.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/00_MDI_01 MASTER LIST OF SM DOCUMENTS INFORMATION.pdf`, type: "pdf" },
    { name: "1_Timetable.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/1_Timetable.pdf`, type: "pdf" },
    { name: "2_Academic.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/2_Academic.pdf`, type: "pdf" },
    { name: "3_Project.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/3_Project.pdf`, type: "pdf" },
    { name: "4_CO-PO.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/4_CO-PO.pdf`, type: "pdf" },
    { name: "5_Lab.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/5_Lab.pdf`, type: "pdf" },
    { name: "6_Feedback.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/6_Feedback.pdf`, type: "pdf" },
    { name: "7_IIPC.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/7_IIPC.pdf`, type: "pdf" },
    { name: "8_Research.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/8_Research.pdf`, type: "pdf" },
    { name: "9_TrainingFaculty_Staff.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/9_TrainingFaculty_Staff.pdf`, type: "pdf" },
    { name: "10_Association.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/10_Association.pdf`, type: "pdf" },
    { name: "11_Budget.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/11_Budget.pdf`, type: "pdf" },
    { name: "12_Alumni.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/12_Alumni.pdf`, type: "pdf" },
    { name: "13_Test.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/13_Test.pdf`, type: "pdf" },
    { name: "14_Placement.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/14_Placement.pdf`, type: "pdf" },
    { name: "15_MinutesofMeeting.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/15_MinutesofMeeting.pdf`, type: "pdf" },
    { name: "16_COE.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/16_COE.pdf`, type: "pdf" },
    { name: "17_LIBRARY.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/17_LIBRARY.pdf`, type: "pdf" },
    { name: "18_PHYSICAL EDUCATION.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/18_PHYSICAL EDUCATION.pdf`, type: "pdf" },
    { name: "19_Transport.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/19_Transport.pdf`, type: "pdf" },
    { name: "20_Admission.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/20_Admission.pdf`, type: "pdf" },
    { name: "21_CDC.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/21_CDC.pdf`, type: "pdf" },
    { name: "22_HOSTEL.pdf", path: `${EOMS_BASE_PATH}/MDF/PDF/22_HOSTEL.pdf`, type: "pdf" }


];

const eomsMdiFiles = [
    { name: "MDI_01 MDI List.pdf", path: `${EOMS_BASE_PATH}/MDI/PDF/MDI_01 MASTER LIST OF SM DOCUMENTS INFORMATION.pdf`, type: "pdf" },
    { name: "MDI_04 Format Change.pdf", path: `${EOMS_BASE_PATH}/MDI/PDF/MDI_04 FORMAT CHANGE REQUISITION SLIP.pdf`, type: "pdf" },
    { name: "MDI_08 Complaint Reg.pdf", path: `${EOMS_BASE_PATH}/MDI/PDF/MDI_08 CUSTOMER COMPLAINT REGISTER.pdf`, type: "pdf" },
    { name: "MDI_09 Quality Plan.pdf", path: `${EOMS_BASE_PATH}/MDI/PDF/MDI_09 QUALITY PLAN.pdf`, type: "pdf" },
    { name: "MDI_11 Intra Audit.pdf", path: `${EOMS_BASE_PATH}/MDI/PDF/MDI_11 INTRA DEPARTMENT AUDIT REPORT.pdf`, type: "pdf" },
    { name: "MDI_12 Inter Audit.pdf", path: `${EOMS_BASE_PATH}/MDI/PDF/MDI_12 INTER DEPARTMENT AUDIT REPORT.pdf`, type: "pdf" },
    { name: "MDI_13 NC Report.pdf", path: `${EOMS_BASE_PATH}/MDI/PDF/MDI_13 NON CONFIRMATIVE REPORT.pdf`, type: "pdf" },
    { name: "MDI_15 Action Taken.pdf", path: `${EOMS_BASE_PATH}/MDI/PDF/MDI_15 ACTION TAKEN REPORT FOR AUDIT.pdf`, type: "pdf" },
    { name: "MDI_16 Student Feedback.pdf", path: `${EOMS_BASE_PATH}/MDI/PDF/MDI_16 ACTION TAKEN FOR STUDENT FEEDBACK ABOUT THE FACULTY.pdf`, type: "pdf" },
    { name: "MDI_17 Improvement Reg.pdf", path: `${EOMS_BASE_PATH}/MDI/PDF/MDI_17 MONITORING  MEASUREMENT & IMPROVEMENT REGISTER.pdf`, type: "pdf" },
    { name: "MDI_23 IMPACT ANALYSIS OF ACTION TAKEN.pdf", path: `${EOMS_BASE_PATH}/MDI/PDF/MDI_23 IMPACT ANALYSIS OF ACTION TAKEN.pdf`, type: "pdf" }
];

const eomsMdfDocFiles = [
    "00_MDI_01 MASTER LIST OF SM DOCUMENTS INFORMATION.docx",
    "1_Timetable.docx", "2_Academic.docx", "3_Project.docx", "4_CO-PO.docx",
    "5_Lab.docx", "6_Feedback.docx", "7_IIPC.docx", "8_Research.doc",
    "9_TrainingFaculty_Staff.doc", "10_Association.doc", "11_Budget.doc", "12_Alumni.docx",
    "13_Test.docx", "14_Placement.doc", "15_MinutesofMeeting.docx", "16_COE.docx",
    "17_LIBRARY.doc", "18_PHYSICAL EDUCATION.docx", "19_Transport.docx", "20_Admission.docx", "21_CDC.docx", "22_HOSTEL.docx"

];

const eomsMdiDocFiles = [
    "MDI_01 MASTER LIST OF SM DOCUMENTS INFORMATION.docx",
    "MDI_04 FORMAT CHANGE REQUISITION SLIP.doc",
    "MDI_08 CUSTOMER COMPLAINT REGISTER.docx",
    "MDI_09 QUALITY PLAN.docx",
    "MDI_11 INTRA DEPARTMENT AUDIT REPORT.doc",
    "MDI_12 INTER DEPARTMENT AUDIT REPORT.doc",
    "MDI_13 NON CONFIRMATIVE REPORT.docx",
    "MDI_15 ACTION TAKEN REPORT FOR AUDIT.docx",
    "MDI_16 ACTION TAKEN FOR STUDENT FEEDBACK ABOUT THE FACULTY.docx",
    "MDI_17 MONITORING  MEASUREMENT & IMPROVEMENT REGISTER.doc",
    "MDI_23 IMPACT ANALYSIS OF ACTION TAKEN.doc"
];

const scannedDocuments = [
    { name: "1.EOMS-MANUAL.pdf", path: `${BASE_PATH}/scaned document/1.EOMS-MANUAL.pdf` },
    { name: "2.EOMS-SYSTEM PROCEDURES.pdf", path: `${BASE_PATH}/scaned document/2.EOMS-SYSTEM PROCEDURES.pdf` },
    { name: "3.EOMS-MDI.pdf", path: `${BASE_PATH}/scaned document/3.EOMS-MDI.pdf` },
    { name: "4.EOMS-FORMATS.pdf", path: `${BASE_PATH}/scaned document/4.EOMS-FORMATS.pdf` }
];

const IqacDownloads = () => {
    const { isAuthenticated, loginWithGoogle, logout, user } = useAuth();
    const [error, setError] = useState('');
    const [showArchived, setShowArchived] = useState(false);
    const [activeFolder, setActiveFolder] = useState(null);

    const handleGoogleLogin = async () => {
        setError('');
        const result = await loginWithGoogle();
        if (!result.success) {
            setError(result.error);
        }
    };

    if (!isAuthenticated) {
        return (
            <div className="iqac-wrapper">
                <Navbar />
                <div className="iqac-container container-fluid p-0">
                    <IqacNavbar />
                    <div className="iqac-content downloads-page">
                        <div className="downloads-header-modern">
                            <div className="header-decoration"></div>
                            <div className="header-text-comp">
                                <h1 className="college-title">Internal Quality Assurance Cell (IQAC)</h1>
                            </div>
                            <div className="page-label">
                                <span>IQAC Documents Format</span>
                            </div>
                        </div>

                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                            <div className="card p-4 shadow" style={{ maxWidth: '400px', width: '100%', borderRadius: '15px' }}>
                                <h3 className="text-center mb-4" style={{ color: '#2c3e50', fontWeight: '600' }}>Login to Download</h3>

                                <div className="text-center mb-4">
                                    <p className="text-muted">Please sign in with your institutional account to access IQAC documents.</p>
                                </div>

                                <button onClick={handleGoogleLogin} className="google-sign-in-btn">
                                    <FontAwesomeIcon icon={faGoogle} className="google-icon-wrapper" />
                                    <span>Sign in with Google</span>
                                </button>

                                {error && <div className="alert alert-danger mt-3 p-2" style={{ fontSize: '0.9rem' }}>{error}</div>}

                                <div className="mt-4 text-center text-muted" style={{ fontSize: '0.8rem' }}>
                                    <small>Access provided for @kongu.edu users only</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
    

    return (
        <div className="iqac-wrapper">
            <Navbar />
            <div className="iqac-container container-fluid p-0">
                <IqacNavbar />
                <div className="iqac-content downloads-page">
                    <div className="downloads-header-modern">
                        <div className="header-decoration"></div>
                        <div className="header-text-comp">
                            <h2 className="college-title">Internal Quality Assurance Cell (IQAC)</h2>
                        </div>
                        <div className="page-label">
                            <span>{showArchived ? 'Archived Documents' : 'IQAC Documents Format'}</span>
                        </div>
                    </div>

                    {/* User Controls & Navigation */}
                    <div className="user-controls-bar" style={{ display: 'flex', alignItems: 'center', paddingBottom: '20px' }}>
                        {/* Back Button (Left Aligned) */}
                        {activeFolder && (
                            <button 
                                className="back-btn-iqac" 
                                onClick={() => {
                                    if (activeFolder === 'controlled-copy') {
                                        setActiveFolder('eoms21001');
                                    } else {
                                        setActiveFolder(null);
                                    }
                                }}
                            >
                                <FontAwesomeIcon icon={faArrowLeft} />
                                {activeFolder === 'controlled-copy' ? 'Back to EOMS 21001' : 'Back to Folders'}
                            </button>
                        )}

                        {/* User Profile (Right Aligned) */}
                        <div className="user-profile-pill" style={{ marginLeft: 'auto' }}>
                            <div className="user-info">
                                <div className="user-avatar-icon">
                                    <FontAwesomeIcon icon={faUserTie} />
                                </div>
                                <span>{user?.email}</span>
                            </div>

                            <div className="v-divider" style={{ height: '20px', width: '1px', background: '#e2e8f0' }}></div>

                            <button
                                onClick={logout}
                                className="logout-btn-modern"
                            >
                                <FontAwesomeIcon icon={faSignOutAlt} />
                                Logout
                            </button>
                        </div>
                    </div>

                    {/* Folder Selection View */}
                    {!activeFolder && (
                        <div className="folder-selection-container">
                            <div className="folder-card iso-card" onClick={() => setActiveFolder('iso9001')}>
                                <div className="card-bg-decoration"></div>
                                <div className="folder-content-wrapper">
                                    <div className="icon-container">
                                        <div className="icon-glow"></div>
                                        <FontAwesomeIcon icon={faFolder} className="folder-icon-main" />
                                    </div>
                                    <div className="folder-text">
                                        <h3 className="folder-title">ISO 9001</h3>
                                        <p className="folder-subtitle">International Organization for Standardization</p>
                                    </div>
                                    <div className="folder-action">
                                        <span>View Format</span>
                                        <FontAwesomeIcon icon={faArrowRight} />
                                    </div>
                                </div>
                            </div>

                            <div className="folder-card eoms-card" onClick={() => setActiveFolder('eoms21001')}>
                                <div className="card-bg-decoration"></div>
                                <div className="folder-content-wrapper">
                                    <div className="icon-container">
                                        <div className="icon-glow"></div>
                                        <FontAwesomeIcon icon={faFolder} className="folder-icon-main" />
                                    </div>
                                    <div className="folder-text">
                                        <h3 className="folder-title">EOMS 21001</h3>
                                        <p className="folder-subtitle">Educational Organizations Management System</p>
                                    </div>
                                    <div className="folder-action">
                                        <span>View Format</span>
                                        <FontAwesomeIcon icon={faArrowRight} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* ISO 9001 Content */}
                    {activeFolder === 'iso9001' && (
                        <div className="downloads-grid">
                            {showArchived ? (
                                // ARCHIVED VIEW
                                <>
                                    {archivedCopoFiles.length === 0 && archivedPdfFiles.length === 0 && archivedDocFiles.length === 0 ? (
                                        <div className="no-files-message" style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '50px', color: '#64748b' }}>
                                            <p>No archived documents available at this time.</p>
                                        </div>
                                    ) : (
                                        <>
                                            {/* Archived CO-PO */}
                                            {archivedCopoFiles.length > 0 && (
                                                <div className="download-card copo-sheet">
                                                    <h4>Archived CO-PO Sheets</h4>
                                                    <ul className="iqac-file-list">
                                                        {archivedCopoFiles.map((file, idx) => (
                                                            <li key={idx}>
                                                                <a href={`${ARCHIVED_BASE_PATH}/${file}`} download>
                                                                    <FontAwesomeIcon icon={faFileExcel} className="file-icon excel" />
                                                                    {file}
                                                                </a>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}

                                            {/* Archived PDFs */}
                                            {archivedPdfFiles.length > 0 && (
                                                <div className="download-card pdf-files">
                                                    <h4>Archived PDF Files</h4>
                                                    <ul className="iqac-file-list">
                                                        {archivedPdfFiles.map((name, idx) => (
                                                            <li key={idx}>
                                                                <a href={`${ARCHIVED_BASE_PATH}/${name}`} target="_blank" rel="noopener noreferrer">
                                                                    <FontAwesomeIcon icon={faFilePdf} className="file-icon pdf" />
                                                                    {name}
                                                                </a>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}

                                            {/* Archived DOCs */}
                                            {archivedDocFiles.length > 0 && (
                                                <div className="download-card doc-files">
                                                    <h4>Archived DOC Files</h4>
                                                    <ul className="iqac-file-list">
                                                        {archivedDocFiles.map((name, idx) => (
                                                            <li key={idx}>
                                                                <a href={`${ARCHIVED_BASE_PATH}/${name}`} download>
                                                                    {name.endsWith('.xlsx') ? (
                                                                        <FontAwesomeIcon icon={faFileExcel} className="file-icon excel" />
                                                                    ) : (
                                                                        <FontAwesomeIcon icon={faFileWord} className="file-icon word" />
                                                                    )}
                                                                    {name}
                                                                </a>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </>
                            ) : (
                                // CURRENT VIEW (Existing Layout)
                                <>
                                    {/* Row 1 */}
                                    <div className="download-card quality-plan">
                                        <h4>Quality Plan</h4>
                                        <ul>
                                            <li>
                                                <a
                                                    href={`${BASE_PATH}/qualityplan/00_IQAC_PLAN_01.09.2023.pdf`}
                                                    className="iqac-download-link"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    download
                                                >
                                                    <FontAwesomeIcon icon={faDownload} className="me-2" />
                                                    Download Quality Plan
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="download-card roles">
                                        <h4>Roles and Responsibilities</h4>
                                        <ul>
                                            <li>
                                                <a
                                                    href={`${BASE_PATH}/roles/Roles_v1.pdf`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="roles-link"
                                                >
                                                    <div className="icon-box">
                                                        <FontAwesomeIcon icon={faUserTie} />
                                                    </div>
                                                    <span>View Roles</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>

                                    {/* Row 2 / Large Columns */}
                                    <div className="download-card copo-sheet">
                                        <h4>CO-PO ATTAINMENT SHEET</h4>
                                        <ul className="iqac-file-list">
                                            {copoFiles.map((file, idx) => (
                                                <li key={idx}>
                                                    <a href={file.path} download>
                                                        <FontAwesomeIcon icon={faFileExcel} className="file-icon excel" />
                                                        {file.name}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div className="download-card pdf-files">
                                        <h4>Download PDF Files</h4>
                                        <ul className="iqac-file-list">
                                            {pdfFiles.map((name, idx) => (
                                                <li key={idx}>
                                                    <a href={`${BASE_PATH}/${name}`} target="_blank" rel="noopener noreferrer">
                                                        <FontAwesomeIcon icon={faFilePdf} className="file-icon pdf" />
                                                        {name}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div className="download-card doc-files">
                                        <h4>Download DOC Files</h4>
                                        <ul className="iqac-file-list">
                                            {docFiles.map((name, idx) => (
                                                <li key={idx}>
                                                    <a href={`${BASE_PATH}/${name}`} download>
                                                        {name.endsWith('.xlsx') || name.endsWith('.xls') ? (
                                                            <FontAwesomeIcon icon={faFileExcel} className="file-icon excel" />
                                                        ) : (
                                                            <FontAwesomeIcon icon={faFileWord} className="file-icon word" />
                                                        )}
                                                        {name}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </>
                            )}
                        </div>
                    )}

                    {/* EOMS 21001 Content */}
                    {activeFolder === 'eoms21001' && (
                        <div className="downloads-grid">
                            <div className="download-card quality-plan">
                                <h4>Quality Plan</h4>
                                <ul>
                                    <li>
                                        <a
                                            href={`${BASE_PATH}/qualityplan/00_IQAC_PLAN_01.09.2023.pdf`}
                                            className="iqac-download-link"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            download
                                        >
                                            <FontAwesomeIcon icon={faDownload} className="me-2" />
                                            Download Quality Plan
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div className="download-card roles">
                                <h4>Roles and Responsibilities</h4>
                                <ul>
                                    <li>
                                        <a
                                            href={`${BASE_PATH}/roles/roles&res2026.pdf`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="roles-link"
                                        >
                                            <div className="icon-box">
                                                <FontAwesomeIcon icon={faUserTie} />
                                            </div>
                                            <span>View Roles</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div className="download-card scanned-docs">
                                <h4>Controlled Copy</h4>
                                <ul>
                                    <li>
                                        <button
                                            onClick={() => setActiveFolder('controlled-copy')}
                                            className="files-link"
                                            style={{ border: 'none', width: '100%', background: 'transparent', padding: 0 }}
                                        >
                                            <div className="icon-box">
                                                <FontAwesomeIcon icon={faFolder} />
                                            </div>
                                            <span>View Files</span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            {/* MDI Documents */}
                            <div className="download-card pdf-files">
                                <h4>EOMS - MDI (PDF Documents)</h4>
                                <ul className="iqac-file-list">
                                    {eomsMdiFiles.map((file, idx) => (
                                        <li key={idx}>
                                            <a href={file.path} target="_blank" rel="noopener noreferrer">
                                                <FontAwesomeIcon icon={faFilePdf} className="file-icon pdf" />
                                                {file.name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="download-card doc-files">
                                <h4>EOMS - MDI (Word Documents)</h4>
                                <ul className="iqac-file-list">
                                    {eomsMdiDocFiles.map((name, idx) => (
                                        <li key={idx}>
                                            <a href={`${EOMS_BASE_PATH}/MDI/WORD/${name}`} download>
                                                <FontAwesomeIcon icon={faFileWord} className="file-icon word" />
                                                {name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* MDF Documents */}
                            <div className="download-card pdf-files">
                                <h4>EOMS - MDF (PDF Documents)</h4>
                                <ul className="iqac-file-list">
                                    {eomsMdfFiles.map((file, idx) => (
                                        <li key={idx}>
                                            <a href={file.path} target="_blank" rel="noopener noreferrer">
                                                <FontAwesomeIcon icon={faFilePdf} className="file-icon pdf" />
                                                {file.name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="download-card doc-files">
                                <h4>EOMS - MDF (Word Documents)</h4>
                                <ul className="iqac-file-list">
                                    {eomsMdfDocFiles.map((name, idx) => (
                                        <li key={idx}>
                                            <a href={`${EOMS_BASE_PATH}/MDF/WORD/${name}`} download>
                                                <FontAwesomeIcon icon={faFileWord} className="file-icon word" />
                                                {name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="download-card copo-sheet">
                                <h4>EOMS - CO-PO ATTAINMENT SHEET</h4>
                                <ul className="iqac-file-list">
                                    {eomsCopoFiles.map((file, idx) => (
                                        <li key={idx}>
                                            <a href={file.path} download>
                                                <FontAwesomeIcon icon={faFileExcel} className="file-icon excel" />
                                                {file.name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="download-card copo-sheet">
                                <h4>EXCEL FORMAT</h4>
                                <ul className="iqac-file-list">
                                    {excel.map((file, idx) => (
                                        <li key={idx}>
                                            <a href={file.path} download>
                                                <FontAwesomeIcon icon={faFileExcel} className="file-icon excel" />
                                                {file.name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                        </div>
                    )}

                    {/* Controlled Copy View */}
                    {activeFolder === 'controlled-copy' && (
                        <div className="downloads-grid">
                            <div className="download-card scanned-docs" style={{ gridColumn: 'span 12' }}>
                                <h4>Controlled Copy Files</h4>
                                <ul className="iqac-file-list" style={{ padding: '1.5rem 2rem' }}>
                                    {scannedDocuments.map((file, idx) => (
                                        <li key={idx} style={{ marginBottom: '0.75rem' }}>
                                            <a href={file.path} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center' }}>
                                                <FontAwesomeIcon icon={faFilePdf} className="file-icon pdf" style={{ fontSize: '1.25rem' }} />
                                                <span style={{ fontSize: '1.05rem', fontWeight: '500' }}>{file.name}</span>
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default IqacDownloads;
